let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kk3mm")).then(() => parcelRequire('da6qc'));